import { render, staticRenderFns } from "./IconBoxBand.vue?vue&type=template&id=f46241d4&"
import script from "./IconBoxBand.vue?vue&type=script&lang=js&"
export * from "./IconBoxBand.vue?vue&type=script&lang=js&"
import style0 from "./IconBoxBand.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./IconBoxBand.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports